import * as React from "react"

import { LIMITS_VIEWS } from "../@constants"
import { ChipBlock, CommonIconButton } from "../../@components"


export default function emailCcColumn() {
    return {
		name: "emails", label: 'User Email',
        options: {
            setCellHeaderProps: () => ({ sx: { minWidth: 100 } }),
            setCellProps: () => ({ sx: { textAlign: "center",  maxWidth: 250 } }),
            customBodyRowRenderLite:  (value, row) => {
                const emailsArray = Array.isArray(value) ? value : []
                const emailCCToShow = emailsArray.slice(0, LIMITS_VIEWS.EMAIL_CC)

                return <>
                    <ChipBlock listElements={emailCCToShow} />
                    { value?.length > LIMITS_VIEWS.EMAIL_CC && <CommonIconButton alertSelected={row} />}
                </>
            }
        }
	}
}